import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencilWave: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPencilWave"><Path d="M20.25 6.25L16.75 2.75L2.5 17V20.5H6L20.25 6.25Z" stroke="currentColor" strokeLinecap="square"/><Path d="M21.25 17.75C21.25 17.75 20.0611 19.5444 18.166 19.5444C16.271 19.5444 15.4594 18.115 13.9866 18.115C12.5138 18.115 11.4964 18.9148 10.5 20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPencilWave;
